module.exports = __webpack_public_path__ + "img/almacenes.3f834865.jpeg";